import { combineReducers } from "redux";
import { connectRouter } from 'connected-react-router';
import formValues from './formValues';
import formValuesClient from './formValuesClient';
import stepsSubmitted from './assertionStepsSubmitted';
import stepsClientSubmitted from './assertionStepsClientSubmitted';
import sessionReducer from './sessionReducer';
import userReducer from './userReducer';
import messageReducer from './messageReducer';
import authClient from './authClient';
import { persistReducer } from 'redux-persist'
import paginationReducer from "./laywerUserReducer";
import LoadingReducer from "./LoadingReducer";
import ModalReducer from "./ModalReducer";
import DeleteImageReducer from "./DeleteImageReducer";
import billingReducer from "./billingReducer";
import ModalFreeReducer from "./ModalFreeReducer";
import articlesReducer from './articlesReducer';
import communityReducer from "./communityReducer";
import LegalMatterReducer from "./LegalMatterReducer";
import proposalsReducer from "./proposalsReducer";

/* import authReducer from "../reducers/AuthReducer";
 */

export default history =>
     combineReducers({
       router: connectRouter(history),
       stepsSubmitted,
       stepsClientSubmitted,
       formValues,
       formValuesClient,
       authClient,
       paginationReducer,
       LoadingReducer,
       DeleteImageReducer,
       ModalReducer,
       ModalFreeReducer,
       billingReducer,
       articlesReducer,
       communityReducer,
       LegalMatterReducer,
       proposalsReducer,
       sessionState: sessionReducer,
       userState: userReducer,
       messageState: messageReducer,
        /* user: authReducer */
     });
